import React from 'react';

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => <></>;

export default Loading;
